export default __webpack_public_path__ + "static/media/load.cf3e3143.gif";